import { AbstractControlOptions } from '@angular/forms';

import { EditorBookingItemSetting } from './editor-booking-item-setting.model';
import { EditorDataService } from '../editor-data/editor-data.service';


export class EditorBookingItemSettingEligibility extends EditorBookingItemSetting {
  settingClassName = 'Eligibility';
  serializedName = 'eligibilityId';
  showSummary = false;

  id: string;

  constructor(obj?: any) {
    super({
      inheritableType: obj?.inheritableType ?? null
    });
    this.id = obj?.id ?? null;
  }

  createCopy(): EditorBookingItemSettingEligibility {
    return new EditorBookingItemSettingEligibility({
      id: this.id,
      inheritableType: this.inheritableType
    });
  }

  getTitle(): string {
    return $localize `Eligibility`;
  }

  getHelpText(): string {
    return $localize `Which rule should be used to determine which users are eligible to book?`;
  }

  hasSummary(): boolean {
    return !!this.id;
  }

  getIdAsString(eligibilityRulesNames: { id: string, name: string }[]): string {
    if (this.id === null) { return ''; }
    return eligibilityRulesNames
      .find(eligibilityRulesName => eligibilityRulesName.id === this.id)?.name ?? $localize `Not valid`;
  }

  getFormConfig(_editorData: EditorDataService): {
    controlsConfig: { [key: string]: any; },
    options?: AbstractControlOptions
  } {
    return {
      controlsConfig: { id: [this.id] }
    };
  }

  getFormValues(): any {
    return { id: this.id };
  }

  getEmptyFormValues(): any {
    return { id: null };
  }

  applyFormValues(formValues: any) {
    this.id = formValues.id;
  }

  getSerializedValues(): any {
    return this.id;
  }
}
